import { AgeRangeValue } from 'components/date/AgeRange'
import { PecFormApi } from 'components/form'
import { AgeRangeType, GrupoAlvoBuscaAtivaVacinacaoEnum, StatusVacinacaoEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import {
  BuscaAtivaVacinacao,
  BuscaAtivaVacinacaoFormModel,
  ImunobiologicoBuscaAtiva,
} from './model-buscaAtivaVacinacao'

export const vacinasMap = (
  item: BuscaAtivaVacinacao
): Record<StatusVacinacaoEnum, ReadonlyArray<ImunobiologicoBuscaAtiva>> => ({
  [StatusVacinacaoEnum.ATRASADA]: item.vacinasAtrasadas,
  [StatusVacinacaoEnum.NO_PRAZO]: item.vacinasNoPrazo,
  [StatusVacinacaoEnum.APLICADA]: item.vacinasAplicadas,
})

const placeholderIdadeMaximaGrupoAlvoCriancaByAgeRangeType = {
  [AgeRangeType.ANOS]: 'Idade máxima (9)',
  [AgeRangeType.MESES]: 'Idade máxima (119)',
  [AgeRangeType.DIAS]: 'Idade máxima (3719)',
}

export const getFirstPlaceholderByGrupoAlvoToAgeRangeField: Partial<Record<
  GrupoAlvoBuscaAtivaVacinacaoEnum,
  string
>> = {
  [GrupoAlvoBuscaAtivaVacinacaoEnum.CRIANCAS]: 'Idade mínima (0)',
  [GrupoAlvoBuscaAtivaVacinacaoEnum.ADOLESCENTES]: 'Idade mínima (10)',
  [GrupoAlvoBuscaAtivaVacinacaoEnum.ADULTOS]: 'Idade mínima (20)',
  [GrupoAlvoBuscaAtivaVacinacaoEnum.IDOSOS]: 'Idade mínima (60)',
}

export const getSecondPlaceholderByGrupoAlvoToAgeRangeField = (
  periodo: AgeRangeType
): Partial<Record<GrupoAlvoBuscaAtivaVacinacaoEnum, string>> => ({
  [GrupoAlvoBuscaAtivaVacinacaoEnum.CRIANCAS]: placeholderIdadeMaximaGrupoAlvoCriancaByAgeRangeType[periodo],
  [GrupoAlvoBuscaAtivaVacinacaoEnum.ADOLESCENTES]: 'Idade máxima (19)',
  [GrupoAlvoBuscaAtivaVacinacaoEnum.ADULTOS]: 'Idade máxima (59)',
})

const FAIXA_ETARIA_SEM_LIMITES = '- até -'

export const faixaEtariaFormatter = (faixaEtaria: AgeRangeValue | undefined | null): string => {
  if (!faixaEtaria) return FAIXA_ETARIA_SEM_LIMITES

  if (!isUndefinedOrNull(faixaEtaria.firstValue) && !isUndefinedOrNull(faixaEtaria.secondValue)) {
    return `${faixaEtaria.firstValue} até ${getIdadeAndTipoFaixaEtaria(
      faixaEtaria.tipoFaixaEtaria,
      faixaEtaria.secondValue
    )}`
  }
  if (!isUndefinedOrNull(faixaEtaria.firstValue)) {
    return `Acima de ${getIdadeAndTipoFaixaEtaria(faixaEtaria.tipoFaixaEtaria, faixaEtaria.firstValue)}`
  }
  if (!isUndefinedOrNull(faixaEtaria.secondValue)) {
    return `Abaixo de ${getIdadeAndTipoFaixaEtaria(faixaEtaria.tipoFaixaEtaria, faixaEtaria.secondValue)}`
  }
  return FAIXA_ETARIA_SEM_LIMITES
}

const getIdadeAndTipoFaixaEtaria = (tipoFaixaEtaria: AgeRangeType, idade: number): string => {
  const ageRangeStringMap = {
    [AgeRangeType.ANOS]: 'ano'.pluralizeAndConcatValue(idade),
    [AgeRangeType.MESES]: `${idade} ${idade > 1 ? 'meses' : 'mês'}`,
    [AgeRangeType.DIAS]: 'dia'.pluralizeAndConcatValue(idade),
  }

  return ageRangeStringMap[tipoFaixaEtaria]
}

export const onClearField = (form: PecFormApi<BuscaAtivaVacinacaoFormModel>, field: string) => {
  form.change(field, undefined)
  form.blur(field)
}
